
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Documentation Site`}</h3>
    <ul>
      <li parentName="ul">{`Fresh new documentation site built with PX Blue components`}</li>
      <li parentName="ul">{`New `}<a parentName="li" {...{
          "href": "/resources"
        }}>{`Resources`}</a>{` & `}<a parentName="li" {...{
          "href": "/roadmap"
        }}>{`Roadmap`}</a>{` pages`}</li>
      <li parentName="ul">{`New content for `}<a parentName="li" {...{
          "href": "/design/intro"
        }}>{`designers`}</a></li>
    </ul>
    <h3>{`Component Libraries`}</h3>
    <p>{`We are very pleased to announce a new site for our PX Blue component libraries: `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io"
      }}>{`pxblue-components.github.io`}</a>{`. This site includes usage instructions, API documentation, and a playground for you to try out all of our PX Blue components.`}</p>
    <p>{`We've also introduced new and improved components:`}</p>
    <ul>
      <li parentName="ul">{`For React, we have added components for `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-drawer--get-read-me-story"
        }}>{`Drawer`}</a>{`, `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-list-item-tag--get-read-me-story"
        }}>{`ListItemTag`}</a>{`, `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-spacer--get-read-me-story"
        }}>{`Spacer`}</a>{`, and
`}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-user-menu--get-read-me-story"
        }}>{`UserMenu`}</a></li>
    </ul>
    <h3>{`Typescript Migration`}</h3>
    <ul>
      <li parentName="ul">{`All React and React Native NPM packages are now using Typescript.`}</li>
    </ul>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and improvements`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;